export const EXPLORE_FUNDS = "EXPLORE_FUNDS";
export const EXPLORE_FUNDS_ERROR = "EXPLORE_FUNDS_ERROR";
export const EXPLORE_FUNDS_HIDE_ERROR = "EXPLORE_FUNDS_HIDE_ERROR";
export const EXPLORE_FUNDS_START_LOADER = "EXPLORE_FUNDS_START_LOADER";
export const EXPLORE_FUNDS_STOP_LOADER = "EXPLORE_FUNDS_STOP_LOADER";
